import { useNavigate, useLocation, useParams } from "react-router-dom";
import AddressForm from "../components/AddressForm.js";
import { useAppState } from "../state/AppStateContext.js";

export default function AddressPage() {
  const nav = useNavigate();
  const { search } = useLocation();
  const { productType: ptParam } = useParams(); // /address/:productType
  const params = new URLSearchParams(search);

  const ptQuery = params.get("productType"); // allow /address?productType=...
  const lang = params.get("lang");
  const productType = ptParam || ptQuery || "";

  const { setAddressId, setAddress } = useAppState();

  return (
    <AddressForm
      onNext={({ addressId, address }) => {
        setAddressId(addressId);
        setAddress(address);

        // Preserve lang
        const keepLang = lang ? `?lang=${lang}` : "";

        if (productType) {
          nav(`/vehicle/${encodeURIComponent(productType)}${keepLang}`);
        } else {
          nav(`/vehicle${keepLang}`);
        }
      }}
    />
  );
}
